export default "__VITE_ASSET__cK9LjXR0__"